import {CategoryAPI} from '#/Category';

export interface CategoryState {
    categories: CategoryAPI[];
    flattenCategories: CategoryAPI[];
    hasEmptyCategories: boolean;
}

export const state: CategoryState = {
    categories: [],
    flattenCategories: [],
    hasEmptyCategories: true,
};
